export enum BookingTypeEnum {
  Web = 0,
  OnCall = 1,
  Visit = 2,
  NewWeb = 3,
  NewOnCall = 4,
  NewVisit = 5,
}
